import * as React from "react"
import { cn } from "@/lib/utils"

const Input = React.forwardRef<
  HTMLInputElement,
  React.ComponentProps<"input">
>(({ className, type, ...props }, ref) => {
  return (
    <input
      type={type}
      className={cn(
        "flex h-12 w-full rounded-lg border-2 border-muted-foreground/30 bg-background px-4 py-3 font-normal text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring focus-visible:border-ring disabled:cursor-not-allowed disabled:opacity-50",
        className
      )}
      style={{
        fontFamily: 'Open Sans',
        fontSize: '14px',
        lineHeight: '140%',
      }}
      ref={ref}
      {...props}
    />
  )
})
Input.displayName = "Input"

export { Input } 